/**
 * Store for shapes received from TAK Server.
 * Holds the current set of remote shapes for map rendering.
 */

import { create } from 'zustand';
import type { TakShape } from '@vtak/shared';

/** Shapes store state and actions */
interface ShapesState {
  /** Shapes round-tripped from TAK Server */
  shapes: TakShape[];

  /** Persisted mission areas + AO overlay broadcast by the areas source */
  areaShapes: TakShape[];

  setShapes: (shapes: TakShape[]) => void;
  setAreaShapes: (shapes: TakShape[]) => void;
}

/** Zustand store for inbound TAK shapes and mission-area shapes */
export const useShapesStore = create<ShapesState>((set) => ({
  shapes: [],
  areaShapes: [],
  setShapes: (shapes) => set({ shapes }),
  setAreaShapes: (areaShapes) => set({ areaShapes }),
}));
